import { useEffect } from "react";

export const PREVENT_COPY_SUFFIX_CLASS = "js-custom-copy";

export const useCopySuffix = () => {
  const suffixCopy = (event: ClipboardEvent) => {
    if (window.customCopyInProgress) return;
    if ((event.target as any).closest && (event.target as any).closest(`.${PREVENT_COPY_SUFFIX_CLASS}`))
      return;
    const selection = document.getSelection();
    event?.clipboardData?.setData(
      "text/plain",
      `${selection?.toString()} [Original source: ${window.location.href}]`
    );
    event.preventDefault();
  };

  useEffect(() => {
    document.body.addEventListener("copy", suffixCopy);

    () => {
      document.body.removeEventListener("copy", suffixCopy);
    };
  }, []);
};
